class Error {
  // constructor
  constructor() {
    this.dom = {
      backButton: document.querySelector('.js-back-button')
    };
  }

  pageBack = () => {
    window.history.go(-1);
  }

  init = () => {
    if (this.dom.backButton !== null) {
      this.dom.backButton.addEventListener('click', this.pageBack, { passive: true });
    }
  }
}

export default Error;
